export const NAME = 'consolidation';

export const CONSOLIDATION_INFO_REQUEST = `${NAME}/CONSOLIDATION_INFO_REQUEST`;
export const CONSOLIDATION_INFO_SUCCESS = `${NAME}/CONSOLIDATION_INFO_SUCCESS`;
export const CONSOLIDATION_INFO_FAILURE = `${NAME}/CONSOLIDATION_INFO_FAILURE`;

export const SAVE_CONSOLIDATION_REQUEST = `${NAME}/SAVE_CONSOLIDATION_REQUEST`;
export const SAVE_CONSOLIDATION_SUCCESS = `${NAME}/SAVE_CONSOLIDATION_SUCCESS`;
export const SAVE_CONSOLIDATION_FAILURE = `${NAME}/SAVE_CONSOLIDATION_FAILURE`;

export const CALCULATE_CONSOLIDATION_REQUEST = `${NAME}/CALCULATE_CONSOLIDATION_REQUEST`;
export const CALCULATE_CONSOLIDATION_SUCCESS = `${NAME}/CALCULATE_CONSOLIDATION_SUCCESS`;
export const CALCULATE_CONSOLIDATION_FAILURE = `${NAME}/CALCULATE_CONSOLIDATION_FAILURE`;

export const GET_CONSOLIDATION_RMBAL_REQUEST = `${NAME}/GET_CONSOLIDATION_RMBAL_REQUEST`;
export const GET_CONSOLIDATION_RMBAL_SUCCESS = `${NAME}/GET_CONSOLIDATION_RMBAL_SUCCESS`;
export const GET_CONSOLIDATION_RMBAL_FAILURE = `${NAME}/GET_CONSOLIDATION_RMBAL_FAILURE`;

export const SET_NEW_COLLATERAL_ITEM = `${NAME}/SET_NEW_COLLATERAL_ITEM`;
export const SET_CURRENT_COLLATERAL_ITEM = `${NAME}/SET_CURRENT_COLLATERAL_ITEM`;

export const SET_SSN = `${NAME}/SET_SSN`;
export const SET_MILAGE = `${NAME}/SET_MILAGE`;

export const SET_NEW_COLLATERAL_AMOUNT = `${NAME}/SET_NEW_COLLATERAL_AMOUNT`;
export const SET_CURRENT_COLLATERAL_AMOUNT = `${NAME}/SET_CURRENT_COLLATERAL_AMOUNT`;

export const SET_COLLATERAL_REDEMPTION = `${NAME}/SET_COLLATERAL_REDEMPTION`;
export const SET_COLLATERAL_REDEMPTION_AND_CLEAR_LICENSE_PLATE_CHANGED = `${NAME}/SET_COLLATERAL_REDEMPTION_AND_CLEAR_LICENSE_PLATE_CHANGED`;
export const SET_COLLATERAL_VALUE = `${NAME}/SET_COLLATERAL_VALUE`;
export const SET_ADDITIONAL_DEPOSIT = `${NAME}/SET_ADDITIONAL_DEPOSIT`;
export const SET_INITIAL_DEPOSIT = `${NAME}/SET_INITIAL_DEPOSIT`;

export const SET_CAR_INSURANCE_COMPANY = `${NAME}/SET_CAR_INSURANCE_COMPANY`;
export const SET_CAR_INSURANCE_COMPANIES = `${NAME}/SET_CAR_INSURANCE_COMPANIES`;

export const CAR_INFO_REQUEST = `${NAME}/CAR_INFO_REQUEST`;
export const CAR_INFO_SUCCESS = `${NAME}/CAR_INFO_SUCCESS`;
export const CAR_INFO_FAILURE = `${NAME}/CAR_INFO_FAILURE`;

export const RESET_CONSOLIDATION_STATE = `${NAME}/RESET_CONSOLIDATION_STATE`;

export const SET_TERMS_DUE_DATE_COUNT = `${NAME}/SET_TERMS_DUE_DATE_COUNT`;

export const GET_PERSON_NAME_REQUEST = `${NAME}/GET_PERSON_NAME_REQUEST`;
export const GET_PERSON_NAME_FAILURE = `${NAME}/GET_PERSON_NAME_FAILURE`;
export const GET_SELLER_NAME_SUCCESS = `${NAME}/GET_SELLER_NAME_SUCCESS`;

export const CURRENT_CAR_INFO_REQUEST = `${NAME}/CURRENT_CAR_INFO_REQUEST`;
export const CURRENT_CAR_INFO_SUCCESS = `${NAME}/CURRENT_CAR_INFO_SUCCESS`;
export const CURRENT_CAR_INFO_FAILURE = `${NAME}/CURRENT_CAR_INFO_FAILURE`;

export const SET_DEPOSIT_PERCENTAGE = `${NAME}/SET_DEPOSIT_PERCENTAGE`;

export const SET_LOAN_TYPE = `${NAME}/SET_LOAN_TYPE`;

export const CLEAR_RMBAL_FLAGS = `${NAME}/CLEAR_RMBAL_FLAGS`;